/** @public */
export type TLSvgDefsComponent = React.ComponentType

/** @public */
export const DefaultSvgDefs = () => {
	return null
}
